import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface SubscriptionPayment {
  id: string;
  amount: number;
  payment_date: string;
  subscription_id: string;
  client_id: string;
}

export const useSubscriptionPayments = (clientId: string, subscriptionId: string) => {
  const { currentOrganization } = useAuth();
  
  return useQuery({
    queryKey: ['subscriptionPayments', clientId, subscriptionId, currentOrganization?.id],
    queryFn: async (): Promise<SubscriptionPayment[]> => {
      if (!currentOrganization?.id || !subscriptionId) {
        return [];
      }
      
      const { data, error } = await supabase
        .from('client_payments')
        .select('id, amount, payment_date, subscription_id, client_id')
        .eq('client_id', clientId)
        .eq('subscription_id', subscriptionId)
        .eq('organization_id', currentOrganization.id)
        .order('payment_date', { ascending: false });

      if (error) {
        console.error('Error fetching subscription payments:', error);
        throw error;
      }

      return data || [];
    },
    enabled: !!clientId && !!subscriptionId && !!currentOrganization?.id,
  });
};